module.exports = __webpack_public_path__ + "img/interface OneB Mapper_4 prew.e148cbae.jpg";